/**
 * Strichcodes im Handel (GTIN: EAN-8, UPC-A, EAN-13, GTIN-14) mit Prüfziffer.
 */

/** Prüft Länge und Prüfziffer eines Codes aus Ziffern. */
export function isValidEan(code: string): boolean {
  if (!/^(\d{8}|\d{12}|\d{13}|\d{14})$/.test(code)) {
    return false;
  }
  const digits = [...code].map(Number);
  const check = digits.pop() as number;
  // Von rechts gezählt werden die Ziffern abwechselnd mit 3 und 1 gewichtet.
  const sum = digits.reverse().reduce((total, digit, index) => total + digit * (index % 2 === 0 ? 3 : 1), 0);
  return (10 - (sum % 10)) % 10 === check;
}
